// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_form__title {
  color: var(--dark-blue-title) #00254A;
  font-size: 18px;
  font-weight: 700;
}

.container_form__subtitle {
  color: var(--dark-blue-title) #00254A;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.container_form__title-inputs {
  color: var(--dark-blue-title) #00254A;
  font-size: 16px;
  font-weight: 500;
}

.container_form__title_and_image {
  color: #005CB9;
  font-size: 16px;
  cursor: pointer;
  font-weight: 400;
}

.container_form__radio_title {
  color: var(--dark-blue-title) #00254A;
  font-size: 16px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/pages/fiscal-formation/fiscal-information/style.css"],"names":[],"mappings":"AAAA;EACI,qCAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAGA;EACI,qCAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAJ;;AAIA;EACI,qCAAA;EACA,eAAA;EACA,gBAAA;AADJ;;AAIA;EACI,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AADJ;;AAIA;EACI,qCAAA;EACA,eAAA;EACA,gBAAA;AADJ","sourcesContent":[".container_form__title{\n    color:var(--dark-blue-title)  #00254A;\n    font-size: 18px;\n    font-weight: 700;\n}\n\n\n.container_form__subtitle{\n    color:var(--dark-blue-title)  #00254A;\n    font-family: Roboto;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n}\n\n\n.container_form__title-inputs {\n    color:var(--dark-blue-title)  #00254A;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.container_form__title_and_image{\n    color: #005CB9;\n    font-size: 16px;\n    cursor: pointer;\n    font-weight: 400;\n}\n\n.container_form__radio_title{\n    color: var(--dark-blue-title)#00254A;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
